import React from 'react';
import { m as motion } from 'framer-motion';
import { Container } from './ui/Container';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function GuaranteeSection() {
  return <section className="bg-mp-dark py-20 md:py-24" data-id="element-97" data-mp="9tbe8wppooia">
      <Container data-id="element-98" data-mp="9wpg83ugqvp7">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mx-auto max-w-[820px] rounded-2xl border border-mp-lime/30 bg-mp-card p-8 text-center md:p-12" data-id="element-99" data-mp="et66p4p4xm5g">
          <span className="text-5xl" role="img" aria-label="Escudo de garantía" data-id="element-100" data-mp="sm5ml7stxidj">
            🛡️
          </span>

          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-101" data-mp="xj5od6inbyyu">
            Garantía de satisfacción de 14 días
          </h2>

          <div className="mx-auto mt-6 max-w-[600px] space-y-1 text-sm leading-relaxed text-mp-gray md:text-base" data-id="element-102" data-mp="17j6dj93759ay">
            <p data-id="element-103" data-mp="25ti4sg7ruiyf">
              Si el producto no cumple con lo prometido, escríbenos a{' '}
              <a href="mailto:manualeslistos@gmail.com" className="font-medium text-mp-lime hover:underline" data-id="element-104" data-mp="20s2jcn1omafi">
                manualeslistos@gmail.com
              </a>{' '}
              y te ayudaremos a resolverlo en menos de 24 horas.
            </p>
          </div>
        </motion.div>
      </Container>
    </section>;
}